export default {"src":"/_next/static/media/worrying-man.8ec09642.svg","height":291,"width":330,"blurWidth":0,"blurHeight":0};